import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import type { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { MarketCredit } from '@sorare/core/src/atoms/icons/MarketCredit';
import { LabelS } from '@sorare/core/src/atoms/typography';
import { useAmountWithConversion } from '@sorare/core/src/hooks/useAmountWithConversion';
import type { MonetaryAmountParams } from '@sorare/core/src/lib/monetaryAmount';

import { useConversionCreditForPrice } from '#src/hooks/useConversionCreditForPrice.ts';

const Label = styled(LabelS)`
  white-space: nowrap;
`;
type Props = {
  price: MonetaryAmountParams;
  sport: Sport;
  Wrapper: React.FC<{ children: React.ReactNode }>;
};

export const AmountSaved = ({ price, sport, Wrapper }: Props) => {
  const { absoluteConversionCreditMonetaryAmount } =
    useConversionCreditForPrice({
      price,
      sport,
    });

  const { main } = useAmountWithConversion({
    monetaryAmount: absoluteConversionCreditMonetaryAmount,
  });

  if (absoluteConversionCreditMonetaryAmount.isZero) return null;
  return (
    <Wrapper>
      <MarketCredit width={16} height={16} />
      <Label bold>
        <FormattedMessage
          defaultMessage="{amount} saved"
          values={{ amount: main }}
        />
      </Label>
    </Wrapper>
  );
};
